/* eslint-disable no-param-reassign */
import React, {
  useCallback,
  useContext,
  useEffect,
  useState,
  useMemo,
} from "react";

import { observer } from "mobx-react";

import ComponentContext from "../../../contexts/ComponentContext";
import apiInstance from "../../../services/api";
import normalizeFilters from "../../helpers/normalizeFilters";
import BrowseAllVacancies from "../BrowseAllVacancies/BrowseAllVacancies";
import Loader from "../Loader/Loader";
import JobCard from "./JobCard";

function RelatedJobsList() {
  const {
    predefinedFilters,
    tenantIds,
    resultsPageHref,
    viewAllJobButtonText,
    showViewAllButton,
  } = useContext(ComponentContext);
  const [isLoading, setIsLoading] = useState(true);
  const [jobData, setJobData] = useState([]);

  const fetchJobs = useCallback(() => {
    apiInstance
      .getVacancies(
        normalizeFilters(predefinedFilters),
        {
          fields: [
            "id",
            "jobTitle",
            "location",
            "remuneration",
            "description",
            "company",
          ],
          limit: 5,
        },
        tenantIds,
        predefinedFilters
      )
      .then((response) => {
        setIsLoading(false);
        setJobData(response?.data?.results || []);
      });
  }, []);

  useEffect(() => {
    fetchJobs();
  }, []);

  const browseAllVacanciesContext = useMemo(() => {
    let href = resultsPageHref || "/results";
    if (predefinedFilters.length > 0) {
      const filtersWithValue = predefinedFilters.reduce(
        (acc, filter, index) => {
          if (index === 0) {
            acc += `?${filter.filterName}=${filter.filterValue}`;
          } else {
            acc += `&${filter.filterName}=${filter.filterValue}`;
          }

          return acc;
        },
        ""
      );
      href += filtersWithValue;
    }
    return {
      resultsPageHref: href,
    };
  }, []);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className="related-jobs-list">
      {jobData?.slice(0, 5)?.map((vacancy) => (
        <JobCard key={vacancy.vacancyId} vacancy={vacancy} />
      ))}
      {showViewAllButton ? (
        <ComponentContext.Provider value={browseAllVacanciesContext}>
          <BrowseAllVacancies
            buttonClassName="w-100"
            className="mb-4 browse-all-vacancies"
            text={viewAllJobButtonText || "View all jobs"}
          />
        </ComponentContext.Provider>
      ) : null}
    </div>
  );
}

export default observer(RelatedJobsList);
